import { t as localeText } from "@/shared/lib/translate";
import { useTranslation as useLocaleSubscription } from "react-i18next";
/** Reserve the composer footprint while its module or catalogue arrives. */
export function CreationComposerPending() {
  useLocaleSubscription();
  return <div className="studio-composer-pending" aria-busy="true" aria-label={localeText("interface.loading_creation_controls_cb8f13ae", { defaultValue: "Loading creation controls" })}>
    <div aria-hidden="true" className="studio-composer-pending-prompt" />
    <div aria-hidden="true" className="studio-composer-pending-chips"><span /><span /><span /></div>
  </div>;
}
